
import Room from "../models/Room";
let room2 = new Room("21313", 60, "aad", 2);
export const ROOMS = [room2];
